module.exports = __webpack_public_path__ + "static/media/wands.6178d730.png";